import f, { ODataFilterBuilder } from 'odata-filter-builder';
import * as ODataUtils from '../../../../utils/odata';

export interface ERPApiReadFilterParams {
    companyId?: number;
    lastApiReadDate?: Date;
    onlyIncludeApiReads?: boolean;
}

/**
 * TODO: revise this after backend is updated
 */
export const createERPApiReadFilter = (params: ERPApiReadFilterParams = {}) => {
    const filterRules: ODataFilterBuilder[] = [];

    // TODO: could this work as plain parameter? (observed inconsistent behavior with onlyIncludeApiReads)
    if (params.companyId) {
        filterRules.push(f().eq('CompanyId', params.companyId));
    }

    if (params.onlyIncludeApiReads) {
        filterRules.push(f().ne('LastReadTime', null));
    }

    // Handle standard filter conditions
    let filterString = '';

    if (filterRules.length > 0) {
        // Get the combined filter string from ODataUtils but remove outer parentheses
        let combinedFilter = ODataUtils.andConditions(filterRules).toString();

        if (combinedFilter.startsWith('(') && combinedFilter.endsWith(')')) {
            combinedFilter = combinedFilter.substring(1, combinedFilter.length - 1);
        }

        filterString = combinedFilter;
    }

    if (params.lastApiReadDate) {
        const dateString = params.lastApiReadDate!.toISOString().split('T')[0];
        const dateFilter = `LastReadTime gt ${dateString}`;

        if (filterString) {
            filterString = `${filterString} and ${dateFilter}`;
        } else {
            filterString = dateFilter;
        }
    }

    return filterString || undefined;
};
